import React, { FC, ReactElement } from 'react';
import { ContentCont, HeadlineCont, SubmitButtonCont, ApiErrorCont } from './ResetPassword.styles';
import Notification from '../Notification/Notification';
import SubmitButton from '../SubmitButton/SubmitButton';

interface IResetPassword {
  headline: ReactElement;
  content: ReactElement;
  submit: () => void;
  buttonText: string;
  buttonIcon?: ReactElement;
  apiError?: {
    title: string | null;
    description: string | null;
  };
}

const ResetPassword: FC<IResetPassword> = ({
  headline,
  submit,
  content,
  buttonText,
  buttonIcon,
  apiError,
}) => {
  const message = {
    mode: 'error' as const,
    type: 'static',
    title: apiError?.title || 'error',
    description: apiError?.description || 'error',
  };

  return (
    <>
      <HeadlineCont>{headline}</HeadlineCont>
      <ContentCont>{content}</ContentCont>
      {apiError?.description && (
        <ApiErrorCont data-testid="api-error-notification">
          <Notification data={message} />
        </ApiErrorCont>
      )}
      <SubmitButtonCont data-testid="submit-button-container" onClick={() => submit()}>
        <SubmitButton text={buttonText} icon={buttonIcon} />
      </SubmitButtonCont>
    </>
  );
};

export default ResetPassword;
